import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5532adfa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "db-selection" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Database Selection", -1))
const _hoisted_3 = { class: "form-group" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "dbName" }, "Db Name", -1))
const _hoisted_5 = { class: "form-group" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "allDb" }, "All Db", -1))
const _hoisted_7 = { class: "checkbox-wrapper-31" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", { viewBox: "0 0 35.6 35.6" }, [
  /*#__PURE__*/_createElementVNode("circle", {
    class: "background",
    cx: "17.8",
    cy: "17.8",
    r: "17.8"
  }),
  /*#__PURE__*/_createElementVNode("circle", {
    class: "stroke",
    cx: "17.8",
    cy: "17.8",
    r: "14.37"
  }),
  /*#__PURE__*/_createElementVNode("polyline", {
    class: "check",
    points: "11.78 18.12 15.55 22.23 25.17 12.87"
  })
], -1))
const _hoisted_9 = { class: "navigation" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _withDirectives(_createElementVNode("select", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ($setup.selectedDbName = $event)),
        id: "dbName"
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.dbNames, (dbName) => {
          return (_openBlock(), _createElementBlock("option", { key: dbName }, _toDisplayString(dbName), 1))
        }), 128))
      ], 512), [
        [_vModelSelect, $setup.selectedDbName]
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _hoisted_6,
      _createElementVNode("div", _hoisted_7, [
        _withDirectives(_createElementVNode("input", {
          type: "checkbox",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ($setup.allDb = $event)),
          id: "allDb"
        }, null, 512), [
          [_vModelCheckbox, $setup.allDb]
        ]),
        _hoisted_8
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("button", {
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($setup.goBack && $setup.goBack(...args)))
      }, "Back"),
      _createElementVNode("button", {
        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => ($setup.goNext && $setup.goNext(...args)))
      }, _toDisplayString($setup.allDb ? 'Finish' : 'Next'), 1)
    ])
  ]))
}